<div class="inactivity-card flex-column full-height" [class.completed]="isCompleted">
  <mat-icon [svgIcon]="getIconName()"></mat-icon>
</div>
